// const devBaseUrl = 'https://charge.shenmachong.com/admin/api'
const devBaseUrl = 'https://devcharge.ismyx.com/admin/api'
// const devBaseUrl = 'http://mg4h8yjs.dongtaiyuming.net:17865/admin/api'
const proBaseUrl = 'https://charge.shenmachong.com/admin/api'

// const wsDevUrl = 'ws://localhost:9001/app/api/sm/web/socket'
const wsDevUrl = 'ws://charge.shenmachong.com/app/api/sm/web/socket'
const wsProUrl = 'wss://charge.shenmachong.com/push/api/sm/web/socket'
export default {
  /**
   * @description api请求基础路径
   */
  baseUrl: process.env.NODE_ENV === 'development' ? devBaseUrl : proBaseUrl,
  wsUrl: process.env.NODE_ENV === 'development' ? wsDevUrl : wsProUrl,
  fingerId: '11',
  merchantId: 0,
  realMerchantId:0,
  sign:'',
  signSecret:'none',
  baseInfo:{},
  totalData:{},
  visualPath:'mirror',
  openVisual:false,
  queryParams:'',
  mirrorType:'none',
  ratio:{
    allRatio: 1,
    bikeDeviceRatio: 1,
    bikeOrderRatio: 1,
    bikeTurnoverRatio: 1,
    carDeviceRatio: 1,
    carOrderRatio: 1,
    carTurnoverRatio: 1,
    userCountRatio: 1,
    cityCount: 0,
    deviceRatio: 1,
    orderRatio: 1,
    turnoverRatio: 1,
    incomeRatio:1
  }
}
